import * as Api from '@ViewModels';
import moment from 'moment-timezone';

export interface RunListDateParts {
	/** Day anchor: Today, Yesterday, a weekday name, or a calendar date. */
	primary: string;
	time: string;
	full: string;
}

export const runListDateParts = (date: string | Date, timeZone: string): RunListDateParts => {
	const runMoment = moment(date).tz(timeZone);
	const today = moment().tz(timeZone);
	const time = runMoment.format('h:mm A');
	const full = runMoment.format('MMM D, YYYY [at] h:mm A');
	if (runMoment.isSame(today, 'day')) {
		return { primary: 'Today', time, full };
	}
	if (runMoment.isSame(today.clone().subtract(1, 'day'), 'day')) {
		return { primary: 'Yesterday', time, full };
	}
	// Weekday names only reach six days back — seven would repeat today's own weekday and read as today.
	if (runMoment.isAfter(today.clone().subtract(6, 'day').startOf('day'))) {
		return { primary: runMoment.format('dddd'), time, full };
	}
	if (runMoment.isSame(today, 'year')) {
		return { primary: runMoment.format('MMM D'), time, full };
	}
	return { primary: runMoment.format('MMM D, YYYY'), time, full };
};

export const runTriggerLabel = (trigger: string | undefined): string =>
	trigger === Api.AgentRunTrigger.Scheduled ? 'Scheduled' : 'On-demand';

export const runStatusLabel = (status: Api.EmailExecBriefRunStatus | undefined): string => {
	switch (status) {
		case 'Queued':
			return 'Queued';
		case 'InProgress':
			return 'Running';
		case 'Success':
			return 'Completed';
		case 'Failed':
			return 'Failed';
		default:
			return status ?? 'Unknown';
	}
};
